import ElectricMainComp from "../../components/elecreic/ElectricMainComp"

export const ElectricityReport = ({ title_1, title_2, title }) => {
   
    return <div>
        <ElectricMainComp title_1={title_1} title_2={title_2} title={title} />
    </div>
}